import React from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';
import PagePlaceholder from './PagePlaceholder';
import AdminAccessPanel from './AdminAccessPanel';

export default function AdminRoute() {
  const { session } = useOutletContext() || {};

  if (!session || session.loading) {
    return (
      <PagePlaceholder
        badge="Admin CMS"
        title="Checking admin access"
        description="Verifying your session before loading admin tools."
      >
        <div className="md:col-span-2 rounded-2xl border border-white/10 bg-white/5 p-6 text-slate-300">
          Loading admin session...
        </div>
      </PagePlaceholder>
    );
  }

  if (!session.isAdmin) {
    return (
      <PagePlaceholder
        badge="Admin CMS"
        title="Admin access required"
        description="Sign in with an authorized admin account to manage articles and categories."
      >
        <div className="md:col-span-2">
          <AdminAccessPanel session={session} title="Admin sign-in required" />
        </div>
      </PagePlaceholder>
    );
  }

  return <Outlet />;
}
